import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Phone, FileText } from 'lucide-react';
import { ksbData } from '../../data/ksb';
import PDFModal from '../../components/PDFModal';
import './KSBSubpage.css';

const ValvulasPage = () => {
  const navigate = useNavigate();
  const [flippedCards, setFlippedCards] = useState({});
  const [pdfModal, setPdfModal] = useState(null);
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!%20Quiero%20consultar%20sobre%20válvulas%20KSB`;

  const pageData = ksbData['valvulas'];

  const toggleFlip = (idx, e) => {
    e.stopPropagation();
    setFlippedCards(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  return (
    <>
    <div className="ksb-subpage-container" data-testid="ksb-valvulas-page">
      {/* Hero Section */}
      <section className="ksb-subpage-hero">
        <div className="ksb-subpage-hero-content">
          <h1 className="ksb-subpage-hero-title">{pageData.title}</h1>
          {pageData.intro.map((text, idx) => (
            <p key={idx} className="ksb-subpage-hero-description">{text}</p>
          ))}
        </div>
      </section>

      {/* Cards Section */}
      <section className="ksb-subpage-cards-section">
        <div className="container">
          <div className="ksb-subpage-cards-grid">
            {pageData.sections[0].cards.map((card, idx) => (
              card.catalogLinks ? (
                /* Flip card for catalog */
                <div
                  key={idx}
                  className="flip-card-wrapper"
                  data-testid={`card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className={`flip-card-inner${flippedCards[idx] ? ' flipped' : ''}`}>

                    {/* Front face */}
                    <div className="flip-card-face flip-card-front" onClick={(e) => toggleFlip(idx, e)}>
                      <div className="ksb-subpage-card-image">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="card-image"
                        />
                      </div>
                      <h3 className="ksb-subpage-card-title">{card.title}</h3>
                      <p className="ksb-subpage-card-description">{card.description}</p>
                      <button
                        className="ksb-subpage-card-arrow ksb-flip-trigger"
                        onClick={(e) => toggleFlip(idx, e)}
                        aria-label="Ver catálogos"
                      >→</button>
                    </div>

                    {/* Back face */}
                    <div className="flip-card-face flip-card-back">
                      <h3 className="ksb-subpage-card-title">{card.title}</h3>
                      <div className="flip-card-back-links">
                        {card.catalogLinks.map((link, linkIdx) => (
                          <button
                            key={linkIdx}
                            className="ksb-catalog-link"
                            onClick={() => setPdfModal({ url: link.href, title: link.label })}
                          >
                            <FileText size={16} />
                            {link.label}
                          </button>
                        ))}
                      </div>
                      <button
                        className="ksb-flip-back-btn"
                        onClick={(e) => toggleFlip(idx, e)}
                        aria-label="Volver"
                      >
                        ← Volver
                      </button>
                    </div>

                  </div>
                </div>
              ) : (
                /* Regular card */
                <Card
                  key={idx}
                  className={`ksb-subpage-card${card.href ? ' ksb-subpage-card--clickable' : ''}`}
                  data-testid={`card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={() => card.href && navigate(card.href)}
                >
                  <CardContent className="ksb-subpage-card-content">
                    <div className="ksb-subpage-card-image">
                      <img
                        src={card.image}
                        alt={card.title}
                        className="card-image"
                      />
                    </div>
                    <h3 className="ksb-subpage-card-title">{card.title}</h3>
                    <p className="ksb-subpage-card-description">{card.description}</p>
                    <span className="ksb-subpage-card-arrow">→</span>
                  </CardContent>
                </Card>
              )
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ksb-subpage-cta-section">
        <div className="container">
          <p className="ksb-subpage-cta-text">{pageData.ctaText}</p>
          <Button
            size="lg"
            className="ksb-subpage-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
            data-testid="valvulas-contact-button"
          >
            <Phone className="mr-2" size={20} />
            ¡Contactanos!
          </Button>
        </div>
      </section>
    </div>

    {pdfModal && (
      <PDFModal
        pdfUrl={pdfModal.url}
        title={pdfModal.title}
        onClose={() => setPdfModal(null)}
      />
    )}
    </>
  );
};

export default ValvulasPage;
